// extracted by mini-css-extract-plugin
export var header = "_ub-1";
export var maskBottom = "_ub-6";
export var maskMiddle = "_ub-7";
export var maskTop = "_ub-5";
export var root = "_ub-0";
export var scrollDownButton = "_ub-3";
export var scrollDownButtonHidden = "_ub-4";
export var viewport = "_ub-2";